module.exports = __webpack_public_path__ + "img/19f1962.jpg";